// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__9706r","file":"styles_file__wwhB0"};